var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bannerHtml)?_c('div',{staticClass:"banner-wrapper",domProps:{"innerHTML":_vm._s(_vm.bannerHtml)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }